import {Class, extend, fetch2} from '../utils'
import Searcher from './Searcher'
import Icons from "../resources/icons";

/**
 *
 * @class Searches gst geoservice (http://www.kortforsyningen.dk/dokumentation/geonoeglergeosearch)
 * @constructs Septima.Search.GeoStednavnSearch
 * @param {Object} options GeoSearch expects these properties:
 * @param options.area {string} "muncode" + municipalitycode eg.; "muncode0151"
 * @param options.authParams {Object} Either {ticket: 'ttttt'}, where t is a ticket issued by kortforsyningen or {login: 'lll', password: 'pppp'}
 *
 * @example
 * var geoStednavnSearchOptions = {
 *     onSelect : function(result) {
 *          log('<b>'+ result.data.type + ':</b> '+ result.title + '<br/>');
 *     },
 *     area: "muncode0151",
 *     authParams: {
 *      login: 'xxxx',
 *      password: 'xxxxxx'
 *     }
 * };
 * searchers.push({title : 'GeoSearch Feature', searcher : new Septima.Search.GeoStednavnSearch(geoStednavnSearchOptions)});
 *
 */

export default Class(Searcher, {
  serviceUrl: 'https://kortforsyningen.kms.dk',

  initialize: function (options) {
    this.options = options
    options.usesGeoFunctions = true;
    if (!options.source) {
      options.source = "Kortforsyningen";
    }
    this.source = options.source;
    this.Searcher(options)
    this.type = 'Stednavne'
    this.registerType(this.source, this.type);
    this.area = null;
    if (options.kommunekode){
      var municipalities = options.kommunekode.split(' ');
      for (var i=0;i<municipalities.length;i++){
        municipalities[i] = "muncode0" + municipalities[i];
      }
      this.area = municipalities.join();
    }else if (options.area) {
      this.area = options.area;
    }
    this.authParams = options.authParams;
    this.visUOfficiel = false;
    if (options.visUOfficiel) {
      this.visUOfficiel = options.visUOfficiel;
    }
    this.iconURI = Icons.searchers.geoSearch.result;
  },

  async fetchData(query, caller) {
    caller.fetchSuccess(await this.query(query))
  },

  async query(query) {
    let results = this.createQueryResult()
    let items = await this.fetchItems(query, Math.max(query.limit, 100) + 1)
    let count = items.length
    if (count <= query.limit || query.type === "list.force") {
      for (let item of items.slice(0, query.limit))
        this.addItemAsResult(results, item)
    } else { 
      let title = this.type;
      if (query.queryString.length > 0){
        if (count > Math.max(query.limit, 100)) {
          title += ` (${Math.max(query.limit, 100)}+)`
        } else {
          title += ` (${count})`
        }
      }
      results.addNewQuery(this.source, this.type, title, null, query.queryString, null, null);
    }
    return results
  },

  async fetchItems(query, limit) {
    const params = {};
    params.limit = limit;
    params.resources = 'stednavne_v3';
    if (this.area) {
      params.area = this.area;
    }
    let items = []
    if (query.queryString.length > 0) {
      params.search = query.queryString;
      let response = await fetch2(this.serviceUrl + '/Geosearch?service=GEO', {data: extend(params, this.authParams)});
      if (response.data !== null)
        items = response.data;
    } else {
      params.search = "a b c d e f g h i j k l m n o p q r s t u v x y z æ ø å 0 1 2 3 4 5 6 7 8 9";
      params.limit += 100;
      let response = await fetch2(this.serviceUrl + '/Geosearch?service=GEO', {data: extend(params, this.authParams)})
      if (response.data !== null){
        items = response.data;
        items.sort((item1, item2) => item1.skrivemaade.localeCompare(item2.skrivemaade))
        items = items.slice(0, limit)
      }
    }
    let filteredItems = this.removeDuplicates(items)
    return filteredItems
  },

  removeDuplicates(items) {
    //https://ilikekillnerds.com/2016/05/removing-duplicate-objects-array-property-name-javascript/
    return items.filter((item, pos, arr) => {
      return arr.map(mapObj => mapObj.id_lokalid).indexOf(item.id_lokalid) === pos;
    });
  },

  addItemAsResult(results, item) {
    let navn = item.skrivemaade;
    // Enrich name with alternatives
    if (item.navnestatus === 'officielt' || item.navnestatus === 'suAutoriseret') {
      if ( this.visUOfficiel && item.skrivemaader_uofficiel.length > 0 )
        navn += ' (' + item.skrivemaader_uofficiel + ')'
    } else{
      if (item.skrivemaade_officiel.length > 0)
        navn += ' (' + item.skrivemaade_officiel + ')'
    }
    //Create a description
    let description = item.kvalifikation;
    let resultGeometry = this.translateWktToGeoJsonObject(item.geometryWkt);
    let result = results.addResult(this.source, this.type, navn, description, resultGeometry, item)
    result.id = item.id_lokalid;
  },

  /*
  async get(id) {
    params = extend(params, this.authParams);
    let data = await fetch2(this.serviceUrl + '?servicename=RestGeokeys_v2&method=matrikelnr&f=json&geometry=true', {data: params});
    let results = this.createQueryResult()
    let result = this.addFeatureAsResult(results, feature)
    return result
  },
  addFeatureAsResult(results, feature) {
    let {geometry, properties} = feature
    let result = results.addResult(this.source, this.type, navn, description, resultGeometry, feature)
    result.id = properties.id
    return result
  },
*/

  CLASS_NAME: 'Septima.Search.GeoStednavnSearcher'
})